import * as React from 'react';

import { CircleIcon } from '../../circle-icon/circle-icon';
import { EmojiDivider } from '../emoji-divider/emoji-divider';

export const WinkEmojiDivider = () => {
  return (
    <EmojiDivider
      emoji={<CircleIcon name="smile-wink" size={80} iconSize={32} solid />}
    />
  );
};
